import { render } from "./TongHangCompile.vue?vue&type=template&id=2b2c4595"
import script from "./TongHangCompile.vue?vue&type=script&lang=js"
export * from "./TongHangCompile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__